import "../Css/Download_pdf.css";

const containerStyle = { position: "relative", top: "0px" };
const signatureTableStyle = { width: "70%" };
const signatureCellStyle = { width: "230px" };
const approvedCellStyle = { position: "relative", left: "60px" };
const noBorderStyle = { borderBottom: "none" };
const signatureStyle = { borderBottom: "none", borderLeft: "none", borderRight: "none" };
const cellHeightStyle = { borderBottom: "none", height: "13px" };
const imageStyle = {
  width: "95%",
  marginTop: "4%",
  marginLeft: "2%",
  marginBottom: "3%",
  height: "30px"
};
const rowSpanStyle = { borderLeft: "none", borderRight: "none" };
const rowSpanRightStyle = { borderLeft: "none" };

const PageFooter = ({ pdf, previewuser, previewapproved }) => {
  return (
    <>
      <div style={containerStyle}>
        <table className="WPSnoborder" style={signatureTableStyle}>
          <tbody>
            <tr>
              <td className="WPSSignatureTable" style={signatureCellStyle}>
                Welding Engineer
              </td>
              <td className="WPSSignatureTable" style={approvedCellStyle}>
                Approved By
              </td>
            </tr>
          </tbody>
        </table>
        
        <table id="table" className="WPSTable11">
          <tbody>
            <tr style={noBorderStyle}>
              <th style={noBorderStyle}>Name</th>
              <th style={signatureStyle}>Signature</th>
              <th style={noBorderStyle}>Name</th>
              <th style={{ borderBottom: "none", borderLeft: "none" }}>
                Signature
              </th>
            </tr>
            
            <tr>
              <td style={cellHeightStyle}>
                {pdf[0]?.WPSH_PreparedBy_Name || ""}
              </td>
              <td rowSpan={3} style={rowSpanStyle}>
                {previewuser && (
                  <img
                    style={imageStyle}
                    alt="User Signature"
                    src={previewuser}
                  />
                )}
              </td>
              <td style={cellHeightStyle}>
                {pdf[0]?.WPSH_ApprovedBy_Name || ""}
              </td>
              <td rowSpan={3} style={rowSpanRightStyle}>
                {previewapproved && (
                  <img
                    style={imageStyle}
                    alt="Approved Signature"
                    src={previewapproved}
                  />
                )}
              </td>
            </tr>
            
            <tr>
              <th style={noBorderStyle}>Date</th>
              <th style={noBorderStyle}>Date</th>
            </tr>
            
            <tr>
              <td style={{ height: "13px" }}>
                {pdf[0]?.WPSH_PreparedBy_Date || ""}
              </td>
              <td style={{ height: "13px" }}>
                {pdf[0]?.WPSH_ApprovedBy_Date || ""}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
export default PageFooter; 
